// Small helpers shared across the portal UI.

export function formatDuration(minutes) {
    if (minutes == null) return "";
    if (minutes < 60) return `${minutes} min`;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m === 0 ? `${h}h` : `${h}h ${m}m`;
}
